import * as React from 'react';
import { Graph } from './ChargesOverTime/Graph';
import { DayBreakdown } from './ChargesOverTime/types';
import { Toolbar } from './ChargesOverTime/Toolbar';
import { Patterns } from '../Patterns';
import { HistoricalPerDiemCalendarPeriod } from '../../params';
import { Errors } from '../Errors';

interface Props {
  data: DayBreakdown[];
  showHistoric: boolean;
  calendarPeriod: HistoricalPerDiemCalendarPeriod;
  isLoading: boolean;
  errors: Error[];
}

export const ChargesOverTime: React.FC<Props> = (props) => {
  const { showHistoric, errors } = props;

  const [showAverage, setShowAverage] = React.useState(false);
  const [showHistoricAverage, setShowHistoricAverage] = React.useState(false);

  return (
    <div className="space-y-4">
      <Patterns />
      <Toolbar
        showHistoric={showHistoric}
        showAverage={showAverage}
        showHistoricAverage={showHistoricAverage}
        setShowAverage={setShowAverage}
        setShowHistoricAverage={setShowHistoricAverage}
      />
      <Graph showAverage={showAverage} showHistoricAverage={showHistoricAverage} {...props} />
      <Errors errors={errors} />
    </div>
  );
};
